export let Status = /*#__PURE__*/function (Status) {
  Status["SUCCESS"] = "SUCCESS";
  Status["BLOCKED"] = "BLOCKED";
  Status["FAILED"] = "FAILED";
  return Status;
}({});